import * as React from 'react';

function SvgArrowUpIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.453 7.88l.002.002a.168.168 0 01.036.182.168.168 0 01-.036.054h0l-.003.003a.167.167 0 01-.237 0h0L9.02 5.92l-.854-.857v6.27a.167.167 0 01-.334 0v-6.27l-.854.856-2.193 2.2s0 0 0 0a.17.17 0 01-.24-.24l3.33-3.328a.167.167 0 01.051-.032h0l.01-.004a.167.167 0 01.126 0h0l.01.003c.019.008.037.019.052.033l3.328 3.328h0z"
        fill="#fff"
        stroke="#32D269"
      />
    </svg>
  );
}

export default SvgArrowUpIcon;
